/* unplugin-vue-components disabled */import script from "./Overlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./Overlay.vue?vue&type=script&setup=true&lang=ts"

import "./Overlay.vue?vue&type=style&index=0&id=330ad614&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-330ad614"]])

export default __exports__